import React, { useEffect, useLayoutEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import GameServer from "./GameServer";
import QuizPage from "../quiz/QuizPage";
import { Box, Button } from "@mui/material";

function Activity({ setShowAppBar }) {
  const navigate = useNavigate();
  const { gameCode, lessonId } = useParams();

  useLayoutEffect(() => {
    setShowAppBar(false);
    return () => setShowAppBar(true);
  }, [setShowAppBar]);

  useEffect(() => {
    if (gameCode && lessonId) {
      console.log("🎮 sending msgstudentstartedgame", gameCode, lessonId);
      GameServer.notify(
        gameCode,
        "msgstudentstartedgame",
        { activityId: lessonId },
        {}
      );
    }
  }, [gameCode, lessonId]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "100vh",
        bgcolor: "#f9f9f9",
        p: 2,
        position: "relative",
      }}
    >
      {/* Top-right My Courses button */}
      <Button
        onClick={() => navigate("/coursepage")}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          color: "primary.main",
          textDecoration: "underline",
          textDecorationColor: "#424242",
        }}
      >
        My Courses
      </Button>

      {/* Centered quiz container */}
      <Box sx={{ width: "100%", maxWidth: "950px", mt: 6 }}>
        <QuizPage />
      </Box>
    </Box>
  );
}

export default Activity;
